import { render, staticRenderFns } from "./singlePublisher.vue?vue&type=template&id=0908e25a"
import script from "./singlePublisher.vue?vue&type=script&lang=js"
export * from "./singlePublisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports